<template>
  <div class="status-panel" :style="borderColor">
    <div class="is-flex">
      <div class="is-flex flex-align--center grow">
        <div class="has-text-grey-light" style="margin: 1rem; font-size: 12px;">
          <font-awesome-icon size="3x" :icon="matchStatusIcon"/>
        </div>
        <div class="is-flex flex-direction--column flex-align--start">
          <div class="status-panel--header">
            {{ matchStatus }}
          <span class="has-text-grey-light">
            {{ noMatchesResolved }}
          </span>
          </div>
          <div class="subtext-font-size" style="color: #666">
            {{ matchDescription }}
          </div>
          <div class="subtext-font-size" style="color: #666">
            {{ matchUserDescription }} {{ matchDate }}
          </div>
        </div>
      </div>
      <div class="is-flex">
        <div
          class="
            status-panel--actions
            is-flex
            flex-direction--column
            flex-justify--center
            flex-align--start
            subtext-font-size
          "
        >
          <router-link
            v-if="pendingCount"
            :to="{ path: `/${getActiveModule.name}/nearMatches`, query: { dmBatchId: batchId }}"
          >
            View Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }} List
          </router-link>
          <router-link v-else :to="{ path: `/${getActiveModule.name}` }">View Home Page</router-link>
          <router-link
            :to="{ path: `/${getActiveModule.name}/transactions/${nearMatchId}/details` }">
              View Transaction Details
            </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { mapGetters } from 'vuex';
import moment from 'moment';
import {
  faCheckCircle,
  faExclamationCircle,
  faStopCircle,
  faWindowClose,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faCheckCircle,
  faExclamationCircle,
  faStopCircle,
  faWindowClose,
);

export default {
  props: {
    batchId: {
      stype: Number,
    },
    decisionStatus: {
      type: String,
    },
    nearMatches: {
      type: Object,
    },
    isResolvedMatch: {
      type: Boolean,
    },
    isResolvedNoMatch: {
      type: Boolean,
    },
    matchStatusIcon: {
      type: Array,
      required: true,
    },
    nearMatchId: {
      type: [String, Number],
      required: true,
    },
    pendingCount: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters('appModules', [
      'getActiveModule',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    borderColor() {
      let color;
      if (this.decisionStatus === 'Pending') {
        color = '#ed7d31';
      } else if (this.decisionStatus === 'Canceled') {
        color = '#c00000';
      } else if (this.isResolvedMatch) {
        color = '#28a745';
      } else if (this.isResolvedNoMatch) {
        color = '#0070c0';
      }
      return `border-left: 10px solid ${color}`;
    },
    matchDescription() {
      let s = null;
      if (this.decisionStatus === 'Pending') {
        s = 'A Match Decision is required.';
      } else if (this.decisionStatus === 'Canceled') {
        s = 'The submission record has been canceled.';
      } else if (this.isResolvedMatch) {
        s = 'The submission record was matched to an existing record.';
      } else if (this.isResolvedNoMatch) {
        s = 'The submission record was not matched to an existing record.';
      } return s;
    },
    matchUserDescription() {
      let s = null;
      if (this.decisionStatus === 'Pending') {
        s = `Record submitted by: ${this.user}`;
      } else if (this.decisionStatus === 'Canceled') {
        s = `Canceled by: ${this.user}`;
      } else if (this.isResolvedMatch || this.isResolvedNoMatch) {
        s = `Resolved by: ${this.user}`;
      } return s;
    },
    matchStatus() {
      let s = null;
      if (this.decisionStatus === 'Pending') {
        s = `Pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es) Queued`;
      } else if (this.isResolvedMatch) {
        s = 'Match Decision';
      } else if (this.isResolvedNoMatch) {
        s = 'No Match Decision';
      } else if (this.decisionStatus === 'Canceled') {
        s = 'Canceled';
      } return s;
    },
    noMatchesResolved() {
      let s = null;
      if (this.isResolvedNoMatch) {
        s = '(No Matching Record)';
      }
      return s;
    },
    user() {
      let userEmail = '';
      if (this.decisionStatus) {
        userEmail = this.$store.state.user.email;
      }
      return `${userEmail}`;
    },
    matchDate() {
      let newDate = '';
      if (this.decisionStatus === 'Resolved' || this.decisionStatus === 'Canceled') {
        newDate = `on ${moment(this.nearMatches.dmMatchResolutionTrans.transDate).format('MM/DD/YYYY')}`;
      } else if (this.decisionStatus === 'Pending') {
        newDate = `on ${moment(this.nearMatches.transDate).format('MM/DD/YYYY')}`;
      }
      return `${newDate}`;
    },
  },
};
</script>

<style lang="sass" scoped>
  .status-panel
    border: 1px solid #bbb
    background-color: #f9f9f9
    box-shadow: 0 0 3px #aaa
    padding: 12px 16px 12px 0
  .status-panel--header
    font-size: 20px
    margin-bottom: 0.25rem
  .status-panel--actions
    border-left: 1px solid #ccc
    padding-left: 1rem
  .subtext-font-size
    font-size: 12px
</style>
